//Action Types
export const SET_USER_PROFILE = "SET_USER_PROFILE";

//Action Creators
export const setUserProfile = value => ({
  type: SET_USER_PROFILE,
  value
});
